import React, { useMemo } from 'react';
import { Card as BootstrapCard, Col, Row } from 'react-bootstrap';

import Card from 'components/DesignSystem/Card';
import EditButton from 'components/Shared/EditButton';
import MapaGaleria from 'components/Relatorios/Decomp/MapaGaleria';
import RichHtml from 'components/RichHtml';
import { decompMediaUrl } from 'services/api/products/relatorios';
import { DecompChuva } from 'types/Relatorios/Decomp';

/**
 * Layout compartilhado das abas de chuva (Observada/Prevista): painel de texto
 * (HTML sanitizado) à esquerda e galeria de mapas à direita. Apresentacional —
 * recebe `data` já carregado; resolve as URLs das imagens (root-relative →
 * origem do mock quando aplicável) antes de repassar à galeria.
 *
 * `variant="intersemanal"` liga o visual alinhado ao Figma do Informe
 * Intersemanal (Card do DesignSystem + título na galeria + mapas empilhados
 * por grupo). O DECOMP não passa essa prop e mantém o visual legado (Card do
 * react-bootstrap + abas de grupo) intocado.
 */
export default function ChuvaLayout({
  data,
  canEdit = false,
  variant = 'legacy',
  galeriaTitulo,
}: {
  data: DecompChuva;
  canEdit?: boolean;
  variant?: 'legacy' | 'intersemanal';
  galeriaTitulo?: string;
}) {
  const grupos = useMemo(
    () => data.grupos.map((g) => ({
      ...g,
      mapas: g.mapas.map((m) => ({ ...m, imagem_url: decompMediaUrl(m.imagem_url) })),
    })),
    [data.grupos],
  );

  if (variant === 'intersemanal') {
    return (
      <Row className="g-3">
        <Col md={5}>
          <Card
            className="h-100"
            title="TEXTO"
            actions={canEdit && <EditButton id="edit-chuva" onClick={() => undefined} />}
          >
            <RichHtml html={data.texto_html} className="w-100 ql-editor" />
          </Card>
        </Col>
        <Col md={7}>
          <Card className="h-100" title={galeriaTitulo}>
            <MapaGaleria grupos={grupos} variant="empilhado" />
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <Row className="g-3">
      <Col md={5}>
        <BootstrapCard className="shadow-sm h-100">
          <BootstrapCard.Header className="d-flex">
            <div className="flex-fill">TEXTO</div>
            {canEdit && (
              <div className="h-100 d-flex align-items-center">
                <EditButton id="edit-chuva" onClick={() => undefined} />
              </div>
            )}
          </BootstrapCard.Header>
          <BootstrapCard.Body>
            <RichHtml html={data.texto_html} className="w-100 ql-editor" />
          </BootstrapCard.Body>
        </BootstrapCard>
      </Col>
      <Col md={7}>
        <MapaGaleria grupos={grupos} />
      </Col>
    </Row>
  );
}
